import { Injectable } from '@angular/core';
import { HubConnection } from '@microsoft/signalr';
import { NotificationCenterMessageDto } from '../notifications/notification-center/models/notification-center-message-dto.model';
import { NotificationCenterService } from '../notifications/notification-center/notification-center.service';
import { ISignalRService } from './signalr-service.interface';

@Injectable({ providedIn: 'root' })
export class SignalRNotificationService implements ISignalRService {
  constructor(private notificationCenterService: NotificationCenterService) {}

  /** @inheritdoc */
  registerOnServerEvents(connection: HubConnection): void {
    connection.on('ReceiveNotification', (notificationDto: NotificationCenterMessageDto) => {
      this.notificationCenterService.receiveNotification(notificationDto);
    });
  }
}
